import React, { useState, useEffect } from 'react';
import FilterSelect from '../filterSelect';
import CreatableSelect from 'react-select/creatable';
import { getCenterCodes, getApplicationCodes, getPurchasingGroupsAdmin, getAreasOrders, getStatusOC, getUsersCodes, getPaymentConditions, getGroupsArticle } from '../../../client/purchaseOrder';
import { searchSuppliersByName } from '../../../client/suppliers';
import DateRangeFilter from '../dateRangeFilter';
import { useAuth } from '../../../context/auth';

const ListFilter = ({
  titleCategory = "Categoría",
  titleOption,
  filters,
  showCategoryFilter = false,
  showCategoryFilterOCAdmin = false,
  categoryOptions = [],
  onCategoryChange = () => { },
  onCenterCodesChange = () => { },
  onFilterChange = () => { },
  onDateRangeChange = () => { },
  onDeliveryDateRangeChange = () => {},
  applyFilters,
  resetStatusFilter,
  resetFlag,
  activeFilters = {},
  widthPx = 105,
  onSuppliersChange = () => { },
  position= "md:right-0 right-auto",
  isLoading = false 
}) => {

  const { supplierId } = useAuth();

  const [showFilters, setShowFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});

  const [isMobile, setIsMobile] = useState(false);

  //centros
  const [centerOptions, setCenterOptions] = useState([]);
  const [selectedCenters, setSelectedCenters] = useState([]);
  const [loadingCenters, setLoadingCenters] = useState(false);

  //estados
  const [statusOptions, setStatusOptions] = useState([]);
  const [loadingStatus, setLoadingStatus] = useState(false);
const [selectedStatus, setSelectedStatus] = useState([]); 

  // áreas(Categorias)
  const [areaOptions, setAreaOptions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [loadingAreas, setLoadingAreas] = useState(false);

  //grupos de compras
  const [purchasingGroupOptions, setPurchasingGroupOptions] = useState([]);
  const [selectedPurchasingGroups, setSelectedPurchasingGroups] = useState([]);
  const [loadingPurchasingGroups, setLoadingPurchasingGroups] = useState(false);

  // comprador: usercodes
  const [userOptions, setUserOptions] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  //Cond de pago:
  const [paymentConditionOptions, setPaymentConditionOptions] = useState([]);
  const [selectedPaymentConditions, setSelectedPaymentConditions] = useState([]);
  const [loadingPaymentConditions, setLoadingPaymentConditions] = useState(false);

  //Proveedores:
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [loadingSuppliers, setLoadingSuppliers] = useState(false);

  //Grupos articulos
  const [groupArticleOptions, setGroupArticleOptions] = useState([]);
  const [selectedGroupArticles, setSelectedGroupArticles] = useState([]);
  const [loadingGroupArticles, setLoadingGroupArticles] = useState(false);

  // comprador: cod solicitante
  const [appOptions, setAppOptions] = useState([]);
  const [selectedApp, setSelectedApp] = useState([]);
  const [loadingApp, setLoadingApp] = useState(false);


  //filtros fecha creacion, liberacion oc admin


  const [selectedReleaseDateRange, setSelectedReleaseDateRange] = useState({
    startDate: '',
    endDate: ''
  });


  const getDefaultDateRange = () => {

    return {
      startDate: '',
      endDate: ''
    };
  };
  const [selectedCreationDateRange, setSelectedCreationDateRange] = useState(getDefaultDateRange());
  //filtro de fechas de creacion oc proveedor
  const [selectedDateRange, setSelectedDateRange] = useState(getDefaultDateRange());

  const [selectedDeliveryDateRange, setSelectedDeliveryDateRange] = useState({
    startDate: '',
    endDate: ''
  });


  // Resetear todos los estados internos cuando cambia resetFlag
  useEffect(() => {
    setSelectedCenters([]);
    setSelectedStatus([]);
    setSelectedDateRange(getDefaultDateRange());
    setSelectedCreationDateRange(getDefaultDateRange());
    setSelectedReleaseDateRange({ startDate: '', endDate: '' });
    setSelectedDeliveryDateRange({ startDate: '', endDate: '' });
    setSelectedFilters({});
    setSelectedCategories([]);
    setSelectedPurchasingGroups([]);
    setSelectedSuppliers([]);
    setSelectedGroupArticles([]);
    setSelectedPaymentConditions([]);
    setSelectedUsers([]);
    setSelectedApp([]);
  }, [resetFlag]);

  useEffect(() => {
    if (showFilters && showCategoryFilterOCAdmin) {
      fetchAreas();
    }
  }, [showFilters, showCategoryFilterOCAdmin, activeFilters?.creationDateFrom, activeFilters?.creationDateTo]);

  useEffect(() => {
    if (activeFilters.userCodes && userOptions.length > 0) {
      setSelectedUsers(prev => {
        const newUsers = (activeFilters.userCodes || []).map(code =>
          ({ value: code, label: code })
        );
        return newUsers;
      });
    }
  }, [activeFilters.userCodes, userOptions]);

  useEffect(() => {
    if (activeFilters.applicationCodes && appOptions.length > 0) {
      setSelectedApp(prev => {
        const newApp = (activeFilters.applicationCodes || []).map(code =>
          ({ value: code, label: code })
        );
        return newApp;
      });
    }
  }, [activeFilters.applicationCodes, appOptions]);

  useEffect(() => {
    if (centerOptions.length > 0) {
      setSelectedCenters(prev => {
        const newCenters = (activeFilters.centerCodes || []).map(code =>
          ({ value: code, label: code })
        );
        return newCenters;
      });
    }
  }, [activeFilters.centerCodes, centerOptions]);

useEffect(() => {
  if (activeFilters.statusIds && statusOptions.length > 0) {
    const matchingStatuses = activeFilters.statusIds
      .map(id => statusOptions.find(option => option.value === id.toString()))
      .filter(Boolean);
    setSelectedStatus(matchingStatuses);
  } else if (!activeFilters.statusIds || activeFilters.statusIds.length === 0) {
    setSelectedStatus([]);
  }
}, [activeFilters.statusIds, statusOptions]);

  useEffect(() => {
    if (activeFilters.areas) {
      setSelectedCategories(activeFilters.areas);
    }
  }, [activeFilters.areas]);

  useEffect(() => {
    if (activeFilters.paymentConditions && paymentConditionOptions.length > 0) {
      setSelectedPaymentConditions(prev => {
        const newConditions = (activeFilters.paymentConditions || []).map(code =>
          ({ value: code, label: code })
        );
        return newConditions;
      });
    }
  }, [activeFilters.paymentConditions, paymentConditionOptions]);


  useEffect(() => {
    if (activeFilters.groupArticles && groupArticleOptions.length > 0) {
      setSelectedGroupArticles(prev => {
        const newGroups = (activeFilters.groupArticles || []).map(code =>
          ({ value: code, label: code })
        );
        return newGroups;
      });
    }
  }, [activeFilters.groupArticles, groupArticleOptions]);

useEffect(() => {
  if (activeFilters.supplierIds && activeFilters.supplierIds.length > 0 && selectedSuppliers.length === 0 && supplierOptions.length > 0) {
    const initialSuppliers = activeFilters.supplierIds
      .map(id => {
        const found = supplierOptions.find(opt => opt.value === id.toString());
        return found || { value: id.toString(), label: id.toString() };
      })
      .filter(Boolean);
    
    if (initialSuppliers.length > 0) {
      setSelectedSuppliers(initialSuppliers);
    }
  }
}, [activeFilters.supplierIds, supplierOptions, selectedSuppliers.length]);

const fetchAppCodes = async () => {
  try {
    setLoadingApp(true);

    const from = activeFilters?.creationDateFrom || activeFilters?.emissionDateFrom;
    const to = activeFilters?.creationDateTo || activeFilters?.emissionDateTo;

    const response = await getApplicationCodes(from, to);

    const apps = Array.isArray(response.data.data)
      ? response.data.data.map((code) => ({
          value: code,
          label: code,
        }))
      : [];

    setAppOptions(apps);
  } catch (error) {
    console.error("❌ Error al cargar códigos de solicitante:", error);
  } finally {
    setLoadingApp(false);
  }
};


const fetchAreas = async () => {
  try {
    setLoadingAreas(true);

    const from = activeFilters?.creationDateFrom || activeFilters?.emissionDateFrom;
    const to = activeFilters?.creationDateTo || activeFilters?.emissionDateTo;

    const response = await getAreasOrders(from, to);

    const areas = Array.isArray(response.data.areas)
      ? response.data.areas.map((area) => ({
          id: area.id,
          name: area.name,
          status: area.status,
        }))
      : [];

    setAreaOptions(areas);
  } catch (error) {
    console.error("❌ Error al cargar áreas:", error);
  } finally {
    setLoadingAreas(false);
  }
};

const fetchPurchasingGroups = async () => {
  try {
    setLoadingPurchasingGroups(true);

    const from = activeFilters?.creationDateFrom || activeFilters?.emissionDateFrom;
    const to = activeFilters?.creationDateTo || activeFilters?.emissionDateTo;

    const response = await getPurchasingGroupsAdmin(from, to);

    const groups = Array.isArray(response.data.purchasingGroups)
      ? response.data.purchasingGroups.map((group) => ({
          value: group.id.toString(),
          label: group.group,
        }))
      : [];

    setPurchasingGroupOptions(groups);
  } catch (error) {
    console.error("❌ Error al cargar grupos de compra (OCAdmin):", error);
  } finally {
    setLoadingPurchasingGroups(false);
  }
};


const fetchUsers = async () => {
  try {
    setLoadingUsers(true);

    const from = showCategoryFilterOCAdmin
      ? (activeFilters?.creationDateFrom || activeFilters?.emissionDateFrom)
      : activeFilters?.emissionDateFrom;

    const to = showCategoryFilterOCAdmin
      ? (activeFilters?.creationDateTo || activeFilters?.emissionDateTo)
      : activeFilters?.emissionDateTo;


    const response = await getUsersCodes(from, to);

    const users = Array.isArray(response.data.data)
      ? response.data.data.map((user) => ({
          value: user,
          label: user,
        }))
      : [];

    setUserOptions(users);
  } catch (error) {
    console.error("❌ Error al cargar usuarios:", error);
  } finally {
    setLoadingUsers(false);
  }
};

const fetchCenterCodes = async () => {
  try {
    setLoadingCenters(true);

    const from = showCategoryFilterOCAdmin
      ? (activeFilters?.creationDateFrom || activeFilters?.emissionDateFrom)
      : activeFilters?.emissionDateFrom;

    const to = showCategoryFilterOCAdmin
      ? (activeFilters?.creationDateTo || activeFilters?.emissionDateTo)
      : activeFilters?.emissionDateTo;

    const response = await getCenterCodes({
      supplierId: showCategoryFilterOCAdmin ? undefined : supplierId,
      emissionDateFrom: from,
      emissionDateTo: to,
    });

    const centers = Array.isArray(response.data.data)
      ? response.data.data.map((center) => ({
          value: center,
          label: center,
        }))
      : [];

    setCenterOptions(centers);
  } catch (error) {
    console.error("❌ Error al cargar centros:", error);
  } finally {
    setLoadingCenters(false);
  }
};


const fetchStatusOptions = async () => {
  try {
    setLoadingStatus(true);

    const currentSupplierId = showCategoryFilterOCAdmin ? undefined : supplierId;
    const from = activeFilters?.emissionDateFrom;
    const to = activeFilters?.emissionDateTo;

    const response = await getStatusOC(currentSupplierId, from, to);

    const statuses = Array.isArray(response.data)
      ? response.data.map((status) => ({
          value: String(status.id),
          label: status.name,
        }))
      : [];

    setStatusOptions(statuses);
  } catch (error) {
    console.error("❌ Error al cargar estados de OC:", error);
  } finally {
    setLoadingStatus(false);
  }
};


const fetchPaymentConditions = async () => {
  try {
    setLoadingPaymentConditions(true);

    const from = showCategoryFilterOCAdmin
      ? (activeFilters?.creationDateFrom || activeFilters?.emissionDateFrom)
      : activeFilters?.emissionDateFrom;

    const to = showCategoryFilterOCAdmin
      ? (activeFilters?.creationDateTo || activeFilters?.emissionDateTo)
      : activeFilters?.emissionDateTo;

    const response = await getPaymentConditions(from, to);

    const conditions = Array.isArray(response.data.data)
      ? response.data.data.map((condition) => ({
          value: condition,
          label: condition,
        }))
      : [];

    setPaymentConditionOptions(conditions);
  } catch (error) {
    console.error("Error al cargar condiciones de pago:", error);
  } finally {
    setLoadingPaymentConditions(false);
  }
};


const fetchSuppliers = async (searchTerm = "") => {
  if (isLoading) return;

  try {
    setLoadingSuppliers(true);

    const limit = searchTerm.trim() === "" ? 5 : 20;
    const response = await searchSuppliersByName(searchTerm, limit);

    const newSuppliers = Array.isArray(response.data)
      ? response.data.map((s) => ({
          value: s.id.toString(),
          label: `${s.name} - ${s.code}`,
        }))
      : [];

    if (searchTerm.trim() !== "") {
      setSupplierOptions(prevOptions => {
        const selectedMap = new Map(selectedSuppliers.map(s => [s.value, s]));
        const newMap = new Map(newSuppliers.map(s => [s.value, s]));
        
        const merged = [...selectedMap.values(), ...newMap.values()];
        const uniqueMap = new Map(merged.map(item => [item.value, item]));
        
        return Array.from(uniqueMap.values());
      });
    } else {
      setSupplierOptions([...selectedSuppliers]);
    }

  } catch (error) {
    console.error("❌ Error al cargar proveedores:", error);
  } finally {
    setLoadingSuppliers(false);
  }
};

useEffect(() => {
  if (isLoading) return;

  if (selectedSuppliers.length === 0) {
    setSupplierOptions([]);
    return;
  }
  
  setSupplierOptions(prevOptions => {
    const selectedMap = new Map(selectedSuppliers.map(s => [s.value, s]));
    const prevMap = new Map(prevOptions.map(opt => [opt.value, opt]));
    
    const merged = [...selectedMap.values(), ...prevMap.values()];
    const uniqueMap = new Map(merged.map(item => [item.value, item]));
    
    return Array.from(uniqueMap.values());
  });
}, [selectedSuppliers, isLoading]);

const fetchGroupArticles = async () => {
  try {
    setLoadingGroupArticles(true);

    const from = activeFilters?.creationDateFrom || activeFilters?.emissionDateFrom;
    const to = activeFilters?.creationDateTo || activeFilters?.emissionDateTo;

    const response = await getGroupsArticle(from, to);

    const groups = Array.isArray(response.data.data)
      ? response.data.data.map((group) => ({
          value: group,
          label: group,
        }))
      : [];

    setGroupArticleOptions(groups);
  } catch (error) {
    console.error("❌ Error al cargar grupos de artículos:", error);
  } finally {
    setLoadingGroupArticles(false);
  }
};


  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (resetStatusFilter) {
      setSelectedStatus([]);
      setSelectedCenters([]);
      setSelectedDateRange({ startDate: '', endDate: '' });
      setSelectedCategories([]);
      setSelectedUsers([]);
    }
  }, [resetStatusFilter]);

  useEffect(() => {
    if (showFilters) {
      fetchCenterCodes();
      fetchStatusOptions();
      fetchPurchasingGroups();
      fetchUsers();
      fetchPaymentConditions();
      fetchSuppliers();
      fetchGroupArticles();
      fetchAppCodes();
    }
  }, [
    showFilters,
    activeFilters?.emissionDateFrom,
    activeFilters?.emissionDateTo,
    activeFilters?.creationDateFrom, 
    activeFilters?.creationDateTo, 
    supplierId,
  ]);

  const toggleFilters = () => setShowFilters(!showFilters);


  const handleAppChange = (selectedOptions) => {
    setSelectedApp(selectedOptions);
    onFilterChange(
      "Cod Solicitante:",
      selectedOptions.map(option => option.value)
    );
  };
  const handleFilterChange = (filterTitle, value) => {
    setSelectedFilters(prev => ({ ...prev, [filterTitle]: value }));
    onFilterChange(filterTitle, value);
  };

  const handleDateRangeChange = ({ startDate, endDate }) => {
    setSelectedDateRange({ startDate, endDate });
    setSelectedCreationDateRange({ startDate, endDate });

    onDateRangeChange({ startDate, endDate });
  };



  const handleCategoryChange = (areaId) => {
    setSelectedCategories(prev => {
      const newCategories = prev.includes(areaId)
        ? prev.filter(id => id !== areaId)
        : [...prev, areaId];

      onCategoryChange(newCategories);

      return newCategories;
    });
  };

  const handlePurchasingGroupChange = (selectedOptions) => {
    setSelectedPurchasingGroups(selectedOptions);
    onFilterChange(
      "Grupo de Compras:",
      selectedOptions.map(option => parseInt(option.value))
    );
  };

  const handleCenterChange = (selectedOptions) => {
    setSelectedCenters(selectedOptions);
    onCenterCodesChange(selectedOptions.map(option => option.value));
  };

  const handleUserChange = (selectedOptions) => {
    setSelectedUsers(selectedOptions);
    onFilterChange(
      "Comprador:",
      selectedOptions.map(option => option.value)
    );
  };

  const handlePaymentConditionChange = (selectedOptions) => {
    setSelectedPaymentConditions(selectedOptions);
    onFilterChange(
      "Cond de Pago:",
      selectedOptions.map(option => option.value)
    );
  };

const handleSupplierChange = (selectedOptions) => {

  if (isLoading) return;

  const options = selectedOptions || [];
  setSelectedSuppliers(options);
  
  const idValues = options.map(option => parseInt(option.value));
  
  onSuppliersChange(idValues);
  onFilterChange("Proveedor:", idValues);

  if (options.length === 0) {
    setSupplierOptions([]);
    return;
  }

  setSupplierOptions(options);

};

  const handleGroupArticleChange = (selectedOptions) => {
    setSelectedGroupArticles(selectedOptions);
    onFilterChange(
      "Grupo Artículos:",
      selectedOptions.map(option => option.value)
    );
  };

  const hasActiveFilters = () => {

    const hasDateFilters =
      (activeFilters.emissionDateFrom && activeFilters.emissionDateTo) ||
      (activeFilters.releaseDateFrom && activeFilters.releaseDateTo) ||
      (activeFilters.creationDateFrom && activeFilters.creationDateTo) ||
      //dashboard
      (activeFilters.dateFrom && activeFilters.dateTo);

    return (
      //filtros oc proveedor y admin
      (activeFilters.centerCodes && activeFilters.centerCodes.length > 0) ||
      activeFilters.hasMaterial !== undefined ||
    
      hasDateFilters ||
      (activeFilters.statusIds && activeFilters.statusIds.length > 0) ||
      //proveedor
      activeFilters.deliveryDateFrom ||
      activeFilters.deliveryDateTo ||
      //filtros oc admin
      activeFilters.withAnticipo !== undefined ||
      activeFilters.releaseDateFrom ||
      activeFilters.releaseDateTo ||

      (activeFilters.areas && activeFilters.areas.length > 0) ||
      (activeFilters.purchasingGroups && activeFilters.purchasingGroups.length > 0) ||
      (activeFilters.userCodes && activeFilters.userCodes.length > 0) ||
      (activeFilters.paymentConditions && activeFilters.paymentConditions.length > 0) ||
      (activeFilters.supplierIds && activeFilters.supplierIds.length > 0) ||
      (activeFilters.groupArticles && activeFilters.groupArticles.length > 0) ||
      (activeFilters.applicationCodes && activeFilters.applicationCodes.length > 0)
    );
  };

  return (

    <div className='relative'>
      <button
        onClick={toggleFilters}
        className={`flex items-center justify-center font-itcbook px-2 w-[${widthPx}px]  border-blue-light text-sm border-[1px] h-[40px] rounded-lg ${hasActiveFilters() ? 'bg-blue-light  text-white' : 'bg-transparent text-[#6B7280]'
          }`}
      >
        {titleOption}
      </button>
      {showFilters && (
        <div
          onClick={(e) => e.stopPropagation()}
          className={`md:p-4 p-4 md:px-5 bg-white absolute ${position} top-12  overflow-y-auto max-h-[300px] md:max-h-[400px] rounded-lg w-[266px] sm:w-[372px] z-10  shadow-[0px_1px_3px_0px_#0000004D,0px_4px_8px_3px_#00000026]`}>
          <div className='flex flex-col gap-3 '>
            <p className='text-base text-blue font-itcbold'>Filtrar por</p>
            <div className='w-full h-[1px] md:my-2 bg-[#D9D9D9]'></div>

            {/* Sección de Categoría con Select múltiple (CreatableSelect) */}
            {showCategoryFilterOCAdmin && (
              <div className='flex flex-col gap-2'>
                <p className='text-sm md:text-base text-blue font-itcbook'>
                  {titleCategory}
                </p>
                <CreatableSelect
                  isMulti
                  isLoading={loadingAreas}
                  isDisabled={isLoading || loadingAreas}
                  options={areaOptions.map(area => ({
                    value: area.id,
                    label: area.name
                  }))}
                  value={areaOptions
                    .filter(area => selectedCategories.includes(area.id))
                    .map(area => ({ value: area.id, label: area.name }))
                  }
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions.map(opt => opt.value);
                    setSelectedCategories(selectedIds);
                    onCategoryChange(selectedIds);
                  }}
                  placeholder="Seleccione las categorías"
                  className="text-sm font-itcbook"
                  noOptionsMessage={() => "No hay categorías"}
                  formatCreateLabel={() => ""}
                  isValidNewOption={() => false}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: '40px',
                      maxHeight: '120px',
                      overflow: 'auto',
                      borderColor: '#D1D5DB',
                      '&:hover': { borderColor: '#D1D5DB' },
                      boxShadow: state.isFocused ? 'none' : base.boxShadow,
                    }),
                    menu: (base) => ({
                      ...base,
                      position: 'absolute',
                      zIndex: 9999,
                      marginTop: '4px',
                      width: '100%',
                      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    }),
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </div>
            )}
        
            {/* Sección de Categoría con Radio Buttons DASHBOARD */}
            {showCategoryFilter && (
              <div className='flex flex-col gap-2'>
                <p className='text-sm md:text-base text-blue font-itcbook'>
                  {titleCategory}
                </p>
                <div className="flex flex-col gap-2">
                  {!(categoryOptions.length > 0) ? areaOptions.map((area) => (
                    <label key={area.id} className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        name="category"
                        value={area.id}
                        checked={selectedCategories.includes(area.id)}
                        onChange={() => handleCategoryChange(area.id)}
                        className="hidden"
                      />
                      <div className={`w-5 h-5 border-2 rounded-[3px] flex items-center justify-center 
                      ${selectedCategories.includes(area.id) ? 'border-[#C4C7CC] ' : ''}`}>
                        {selectedCategories.includes(area.id) && (
                          <svg className="w-4 h-4 text-blue" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        )}
                      </div>
                      <span className="text-[#1B1F26B8] font-itcmedium text-xs md:text-sm">
                        {area.name}
                      </span>
                    </label>
                  )) :
                    categoryOptions.map((option, i) => (
                      <label key={"category-" + i} className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          name="category"
                          value={option}
                          checked={selectedCategories.includes(option)}
                          onChange={() => handleCategoryChange(option)}
                          className="hidden"
                        />
                        <div className={`w-5 h-5 border-2 rounded-[3px] flex items-center justify-center 
                          ${selectedCategories.includes(option) ? 'border-[#C4C7CC] ' : ''}`}>
                          {selectedCategories.includes(option) && (
                            <svg className="w-4 h-4 text-blue" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          )}
                        </div>
                        <span className="text-[#1B1F26B8] font-itcmedium text-[14px]">
                          {option}
                        </span>
                      </label>
                    ))}
                </div>
              </div>
            )}

            {filters.map((filter, index) => {
              //filtros oc proveedor

              if (filter.title === "Fecha de entrega:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm md:text-base text-blue font-itcbook'>
                      {filter.title}
                    </p>

                    <DateRangeFilter
                      onDateRangeChange={onDeliveryDateRangeChange}  
                      value={{
                        startDate: activeFilters.deliveryDateFrom || '',
                        endDate: activeFilters.deliveryDateTo || ''
                      }}
                    />
                  </div>
                );
              }
              if (filter.title === "Centro:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm md:text-base text-blue font-itcbook'>
                      {filter.title}
                    </p>
                    <div className="my-1 relat">
                      <CreatableSelect
                        isMulti
                        isLoading={loadingCenters}
                        isDisabled={isLoading || loadingCenters}
                        options={centerOptions}
                        value={selectedCenters}
                        onChange={handleCenterChange}
                        placeholder="Seleccione centros"
                        className="text-sm font-itcbook"
                        noOptionsMessage={() => "No hay opciones"}
                        formatCreateLabel={(inputValue) => ""}
                        isValidNewOption={() => false}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: '40px',
                            maxHeight: '120px',
                            overflow: 'auto',
                            borderColor: '#D1D5DB',
                            '&:hover': {
                              borderColor: '#D1D5DB',
                            },
                            boxShadow: state.isFocused ? 'none' : base.boxShadow,
                          }),
                          menu: (base) => ({
                            ...base,
                            position: 'absolute',
                            zIndex: 9999,
                            marginTop: '4px',
                            width: '100%',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                          }),
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </div>
                );
              }

              if (filter.type === "dateRange") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm md:text-base text-blue font-itcbook'>
                      {filter.title}
                    </p>
                    <DateRangeFilter
                      onDateRangeChange={handleDateRangeChange}
                      value={selectedDateRange}
                    />
                  </div>
                );
              }

              if (filter.title === "Estado de OC:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm text-blue font-itcbook md:text-base'>
                      {filter.title}
                    </p>
                    <CreatableSelect
                      isMulti
                      isDisabled={isLoading || loadingStatus}
                      isLoading={loadingStatus}
                      options={statusOptions}
                      value={selectedStatus}
                      placeholder="Seleccione estado"
                      onChange={(selectedOptions) => {
                        setSelectedStatus(selectedOptions || []);
                        const statusIds = selectedOptions ? selectedOptions.map(opt => parseInt(opt.value)) : [];
                        handleFilterChange(filter.title, statusIds);
                      }}
                      className="text-sm font-itcbook"
                      noOptionsMessage={() => "No hay opciones"}
                      formatCreateLabel={() => ""}
                      isValidNewOption={() => false}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            minHeight: '40px',
                            maxHeight: '120px',
                            overflow: 'auto',
                            borderColor: '#D1D5DB',
                            '&:hover': {
                              borderColor: '#D1D5DB',
                            },
                            boxShadow: state.isFocused ? 'none' : base.boxShadow,
                          }),
                          menu: (base) => ({
                            ...base,
                            position: 'absolute',
                            zIndex: 9999,
                            marginTop: '4px',
                            width: '100%',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                          }),
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                );
              }


              //filtros OC Admin

              if (filter.title === "Año de creación:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm md:text-base text-blue font-itcbook'>
                      {filter.title}
                    </p>
                    <DateRangeFilter
                      onDateRangeChange={({ startDate, endDate }) => {
                        setSelectedCreationDateRange({ startDate, endDate });
                        onDateRangeChange({
                          emissionDateFrom: startDate,
                          emissionDateTo: endDate
                        });
                      }}
                      value={selectedCreationDateRange}
                    />
                  </div>
                );
              }

              if (filter.title === "Año de Liberación:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm md:text-base text-blue font-itcbook'>
                      {filter.title}
                    </p>
                    <DateRangeFilter
                      onDateRangeChange={({ startDate, endDate }) => {
                        setSelectedReleaseDateRange({ startDate, endDate });
                        onDateRangeChange({
                          releaseDateFrom: startDate,
                          releaseDateTo: endDate
                        });
                      }}
                      value={selectedReleaseDateRange}
                    />
                  </div>
                );
              }

              if (filter.title === "Grupo de Compras:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm text-blue font-itcbook md:text-base'>
                      {filter.title}
                    </p>
                    <CreatableSelect
                      isMulti
                      isLoading={loadingPurchasingGroups}
                      isDisabled={isLoading || loadingPurchasingGroups}
                      options={purchasingGroupOptions}
                      value={selectedPurchasingGroups}
                      onChange={handlePurchasingGroupChange}
                      placeholder="Seleccione grupos"
                      className="text-sm font-itcbook"
                      noOptionsMessage={() => "No hay opciones"}
                      formatCreateLabel={(inputValue) => ""}
                      isValidNewOption={() => false}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: '40px',
                          maxHeight: '120px',
                          overflow: 'auto',
                          borderColor: '#D1D5DB',
                          '&:hover': {
                            borderColor: '#D1D5DB',
                          },
                          boxShadow: state.isFocused ? 'none' : base.boxShadow,
                        }),
                        menu: (base) => ({
                          ...base,
                          position: 'absolute',
                          zIndex: 9999,
                          marginTop: '4px',
                          width: '100%',
                          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                        }),
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                );
              }

              if (filter.title === "Comprador:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm text-blue font-itcbook md:text-base'>
                      {filter.title}
                    </p>
                    <CreatableSelect
                      isMulti
                      isLoading={loadingUsers}
                      isDisabled={isLoading || loadingUsers}
                      options={userOptions}
                      value={selectedUsers}
                      onChange={handleUserChange}
                      placeholder="Seleccione compradores"
                      className="text-sm font-itcbook"
                      noOptionsMessage={() => "No hay opciones"}
                      formatCreateLabel={(inputValue) => ""}
                      isValidNewOption={() => false}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: '40px',
                          maxHeight: '120px',
                          overflow: 'auto',
                          borderColor: '#D1D5DB',
                          '&:hover': {
                            borderColor: '#D1D5DB',
                          },
                          boxShadow: state.isFocused ? 'none' : base.boxShadow,
                        }),
                        menu: (base) => ({
                          ...base,
                          position: 'absolute',
                          zIndex: 9999,
                          marginTop: '4px',
                          width: '100%',
                          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                        }),
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                );
              }

              if (filter.title === "Cond de Pago:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm text-blue font-itcbook md:text-base'>
                      {filter.title}
                    </p>
                    <CreatableSelect
                      isMulti
                      isLoading={loadingPaymentConditions}
                      isDisabled={isLoading || loadingPaymentConditions}
                      options={paymentConditionOptions}
                      value={selectedPaymentConditions}
                      onChange={handlePaymentConditionChange}
                      placeholder="Seleccione condiciones"
                      className="text-sm font-itcbook"
                      noOptionsMessage={() => "No hay opciones"}
                      formatCreateLabel={(inputValue) => ""}
                      isValidNewOption={() => false}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: '40px',
                          maxHeight: '120px',
                          overflow: 'auto',
                          borderColor: '#D1D5DB',
                          '&:hover': {
                            borderColor: '#D1D5DB',
                          },
                          boxShadow: state.isFocused ? 'none' : base.boxShadow,
                        }),
                        menu: (base) => ({
                          ...base,
                          position: 'absolute',
                          zIndex: 9999,
                          marginTop: '4px',
                          width: '100%',
                          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                        }),
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                );
              }

              if (filter.title === "Proveedor:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm text-blue font-itcbook md:text-base'>
                      {filter.title}
                    </p>
                    <CreatableSelect
                      isMulti
                      isLoading={loadingSuppliers}
                      isDisabled={isLoading }
                      options={supplierOptions}
                      value={selectedSuppliers}
                      onChange={handleSupplierChange}
                      onInputChange={(inputValue) => {
                        if (!isLoading) {
                          if (inputValue === "") {
                            setSupplierOptions([...selectedSuppliers]);
                            return;
                          }
                          if (inputValue.length >= 2) {
                            fetchSuppliers(inputValue);
                          }
                        }
                      }}
                      placeholder="Seleccione proveedores"
                      className="text-sm font-itcbook"
                      noOptionsMessage={() => "Escriba para buscar proveedores"}
                      formatCreateLabel={() => ""}
                      isValidNewOption={() => false}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: '40px',
                          maxHeight: '120px',
                          overflow: 'auto',
                          borderColor: '#D1D5DB',
                          '&:hover': { borderColor: '#D1D5DB' },
                          boxShadow: state.isFocused ? 'none' : base.boxShadow,
                        }),
                        menu: (base) => ({
                          ...base,
                          position: 'absolute',
                          zIndex: 9999,
                          marginTop: '4px',
                          width: '100%',
                          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                        }),
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />

                  </div>
                );
              }

              if (filter.title === "Grupo Artículos:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm text-blue font-itcbook md:text-base'>
                      {filter.title}
                    </p>
                    <CreatableSelect
                      isMulti
                      isLoading={loadingGroupArticles}
                      isDisabled={isLoading || loadingGroupArticles} 
                      options={groupArticleOptions}
                      value={selectedGroupArticles}
                      onChange={handleGroupArticleChange}
                      placeholder="Seleccione grupos"
                      className="text-sm font-itcbook"
                      noOptionsMessage={() => "No hay opciones"}
                      formatCreateLabel={(inputValue) => ""}
                      isValidNewOption={() => false}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: '40px',
                          maxHeight: '120px',
                          overflow: 'auto',
                          borderColor: '#D1D5DB',
                          '&:hover': {
                            borderColor: '#D1D5DB',
                          },
                          boxShadow: state.isFocused ? 'none' : base.boxShadow,
                        }),
                        menu: (base) => ({
                          ...base,
                          position: 'absolute',
                          zIndex: 9999,
                          marginTop: '4px',
                          width: '100%',
                          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                        }),
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                );
              }

              if (filter.title === "Cod Solicitante:") {
                return (
                  <div key={index} className='flex flex-col gap-2'>
                    <p className='text-sm text-blue font-itcbook md:text-base'>
                      {filter.title}
                    </p>
                    <CreatableSelect
                      isMulti
                      isLoading={loadingApp}
                      isDisabled={isLoading || loadingApp}
                      options={appOptions}
                      value={selectedApp}
                      onChange={handleAppChange}
                      placeholder="Seleccione códigos"
                      className="text-sm font-itcbook"
                      noOptionsMessage={() => "No hay opciones"}
                      formatCreateLabel={(inputValue) => ""}
                      isValidNewOption={() => false}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: '40px',
                          maxHeight: '120px',
                          overflow: 'auto',
                          borderColor: '#D1D5DB',
                          '&:hover': {
                            borderColor: '#D1D5DB',
                          },
                          boxShadow: state.isFocused ? 'none' : base.boxShadow,
                        }),
                        menu: (base) => ({
                          ...base,
                          position: 'absolute',
                          zIndex: 9999,
                          marginTop: '4px',
                          width: '100%',
                          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                        }),
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                );
              }

              return (
                <div key={index} className='flex flex-col gap-2'>
                  <p className='text-sm text-blue font-itcbook md:text-base'>
                    {filter.title}
                  </p>
                  <FilterSelect
                    width='w-full'
                    text={
                            selectedFilters[filter.title] && selectedFilters[filter.title] !== ''
                              ? selectedFilters[filter.title]
                              : filter.title === "Tipo de compra:" 
                                ? "Seleccione tipo"
                                : filter.title === "Con Anticipo:" 
                                  ? "Seleccione condición de anticipo"
                                  : filter.title === "Centro:" 
                                    ? "Seleccione centros"
                                    : "Seleccione una opción"
                          }
                    options={filter.options}
                    onSelect={(option) => handleFilterChange(filter.title, option)}
                  />
                </div>
              );

            })}

            <div className="flex justify-center w-full">
              <button
                onClick={() => {
                  applyFilters();
                  setShowFilters(false);
                }}
                className="underline text-blue font-itcbold">
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}

    </div>

  );
};
export default ListFilter;